import React from 'react';

const UserEvaluationDetails = ({ evaluation }) => (
  <div className='bg-white rounded shadow p-4 mb-6'>
    <h2 className='text-lg font-bold mb-4'>Evaluation Details</h2>
    <table className='w-full table-fixed'>
      <tbody>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Decision</td>
          <td className='py-1'>{evaluation?.status ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Shortlisted</td>
          <td className='py-1'>
            {evaluation?.shortList === true
              ? 'Yes'
              : evaluation?.shortList === false
              ? 'No'
              : '-'}
          </td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>
            Language Proficiency
          </td>
          <td className='py-1'>{evaluation?.languageProficiency ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>
            Technical Fluency Audited
          </td>
          <td className='py-1'>{evaluation?.technicalFluencyAudited ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>
            Communication Fluency Audited
          </td>
          <td className='py-1'>{evaluation?.commFluencyAudited ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Found Copying</td>
          <td className='py-1'>{evaluation?.foundCopying ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Reject Reason</td>
          <td className='py-1 w-[40%]'>
            <div
              className='break-words whitespace-pre-line text-sm leading-relaxed'
              dangerouslySetInnerHTML={{
                __html: evaluation?.rejectReason ?? '-',
              }}
            />
          </td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Email Sent</td>
          <td className='py-1'>{evaluation?.emailSent ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Cohort Name</td>
          <td className='py-1'>{evaluation?.data?.almaXCohort ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>
            Evaluation Date
          </td>
          <td className='py-1'>
            {evaluation?.data?.evaluationDate
              ? new Date(evaluation.data.evaluationDate).toLocaleString()
              : '-'}
          </td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Created At</td>
          <td className='py-1'>
            {evaluation?.createdAt
              ? new Date(evaluation.createdAt).toLocaleString()
              : '-'}
          </td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Updated At</td>
          <td className='py-1'>
            {evaluation?.updatedAt
              ? new Date(evaluation.updatedAt).toLocaleString()
              : '-'}
          </td>
        </tr>
      </tbody>
    </table>
    {/* Interview Notes */}
    {evaluation?.data?.interviewNotes &&
      evaluation.data.interviewNotes.length > 0 && (
        <div className='mt-4'>
          <div className='font-bold mb-2'>Internal Remarks:</div>
          <ul className='list-disc list-inside'>
            {evaluation.data.interviewNotes.map((note, idx) => (
              <li key={idx}>
                <span className='font-medium'>
                  {note.evaluator ? `${note.evaluator}: ` : ''}
                </span>
                {note.remark}
                {note.timestamp && (
                  <span className='text-xs text-gray-500 ml-2'>
                    ({note.timestamp})
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
  </div>
);

export default UserEvaluationDetails;
